module.exports = __webpack_public_path__ + "static/img/gpt1.5d32292f.jpg";